import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { get, getPaymentOfferInfoConfig } from "../../logics/src/utils/helpers";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { SavedPaymentWrapper, SectionTitleWrapper } from "./assets/style";
import { useTheme } from "emotion-theming";
import { doPaymentHandler } from "layouts/Payment/logics/doPaymentHandler";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { UserContext } from "wrapper/UserWrapper/context";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import {
  trackPaymentMethodClick,
  trackPayNowClick,
  trackRenderedSavedMethods,
} from "layouts/Payment/common/dependencies/tracking";
import { OverlayLoader } from "components/OverlayLoader";
import { UpiIntentPollingScreen } from "layouts/CheckoutPayment/UpiIntentPollingScreen";
import { useHistory } from "react-router-dom";

import { PciSdkTypes, PCI_IFRAME_IDS } from "PCI/utills";

import { PAYMENT_MODES } from "../../../shared/constants/paymentModes";
import { getStringFromId } from "../../helpers/vernacular";
import { getSavedUpiMethodContextData } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/upiMethod";
import { getSavedPaytmContextData } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/paytm";
import { getUpiIntentContextData } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/upiIntent";
import { getValidSavedMethod } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/validSavedPaymentMethod";
import { checkAllUpiIntentVisibilityOnWeb } from "layouts/CheckoutPayment/helpers";
import { getSavedNbContextData } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/nb";
import { toLowerCase } from "helpers/utils/toLowerCase";
import { getEndIconforPaymentMethod } from "helpers/utils/getIcons";
import { savedSimpl } from "wrapper/PaymentWrapper/dependencies/utils/SavedPaymentConfig/savedSimpl";
import { RelinkSimplMobile } from "@nykaa/payment-sdk/src/RelinkSimpl/mobile/Loadable";
import { IsavedCardConfig, ISavedNetBanking, ISavedPaytmConfigs, ISavedsnplConfig, ISavedUpiConfigs, ISavedUpiIntent } from "wrapper/PaymentWrapper/dependencies/utils/@types/savedMethods";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { ACCORDIAN, TRACKING_EVENTS } from "constants/index";
import { PAYMENT_METHODS, PAYMENT_FLOWS, PAYMENT_TYPE } from "constants/payment";
import { PAYMENT_OPTION, PAYMENT_SCREENS } from "constants/paymentScreens";

import SavedUpi from "@nykaa/payment-sdk/src/SavedUpi/mobile";
import SavedNB from "@nykaa/payment-sdk/src/SavedNB/mobile";
import GooglePay from "@nykaa/payment-sdk/src/GooglePay/mobile";
import SavedPaytmWallet from "@nykaa/payment-sdk/src/SavedPaytm/mobile";
import PaymentOfferInfo from "@nykaa/payment-sdk/src/PaymentOfferInfo/mobile";
import SavedSimpl from "@nykaa/payment-sdk/src/SavedSimpl/mobile";
import PCI from "PCI/index";
import { Text } from "@nykaa/payment-ui/src/Text";
import { formatNumber } from "helpers/utils/numberFormatter";


export const SavedPaymentView = ({
  setUpiDetails,
  timerCallback,
  isGPayIntentAvailable,
  autoPayTmCreateOrder,
}: any) => {
  const SavedPaymentOption = getStringFromId(VERNACULAR_STRING_IDS.SAVED_PAYMENT_OPTIONS, VERNACULAR_DEFAULT_MESSAGES.SAVED_PAYMENT_OPTIONS);
  const history = useHistory();
  const theme = useTheme() as Theme;
  const { userData } = useContext(UserContext);
  const paymentContext = useContext(PaymentContext);
  const { applicationData } = useContext(ApplicationContext);
  const errorModalContext = useContext(ErrorModalContext);
  const {
    setIsVerifyOtpVisible,
    isOtpVerificationRequired,
    handleCallBackAfterVerification,
  } = useContext(VerifyOtpContext);
  const {
    PCI: PciExperiment,
    NewPaymentFailure,
    UpiIntentMweb,
    UpiIntentMwebPollingScreen,
    ConvenienceCharges,
  } = useContext(ExperimentAndSwitchContext);

  const walletConfig = get(paymentContext, "walletConfig");
  const giftCardConfig = get(paymentContext, "giftCardInfoConfig");
  const orderAmount = get(paymentContext, "orderAmount");
  const paymentInfo = get(paymentContext, "paymentInfo");
  const cartInfo = get(paymentContext, "cartInfo");
  const isPaymentInfoLoading = get(paymentContext, "isPaymentInfoLoading");
  const flow = get(paymentContext, "flow");
  const setLoading = get(paymentContext, "setLoading");
  const setIsAutoCreateOrderLoading = get(paymentContext, "setIsAutoCreateOrderLoading");
  const loading = get(paymentContext, "loading");
  const doPaymentApi = get(paymentContext, "doPaymentApi");
  const isWalletAccordianOpen = get(paymentContext, "isWalletAccordianOpen");
  const setIsWalletAccordianOpen = get(paymentContext, "setIsWalletAccordianOpen");
  const setActiveMethodForSavedPayments = get(paymentContext, "setActiveMethodForSavedPayments");
  const activeMethodForSavedPayments = get(paymentContext, "activeMethodForSavedPayments");
  const { deviceType, isApp } = applicationData;
  const { isGuest } = userData;
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const showStrikedAmount = get(paymentContext, "showStrikedAmount");
  const initialOrderAmount = get(cartInfo, "grandTotal");
  const offerInfo = get(paymentContext, "offersData");
  const setIsPaymentProcessing = get(paymentContext, "setIsPaymentProcessing");
  const loadingParams = get(paymentContext, "loadingParams");
  const availablePaymentMethods = get(cartInfo, "availablePaymentMethods");
  const paymentOption = get(paymentContext, "paymentOption");
  const setPaymentOption = get(paymentContext, "setPaymentOption");
  const paymentScreen = get(paymentContext, "paymentScreen");
  const setCartInfo = get(paymentContext, "setCartInfo");

  const [offerInfoConfig, setOfferInfoConfig] = useState<any>({});
  const [accordian, setAccordian] = useState(0);
  const [allSavedPaymentConfig, setAllSavvedPaymentConfig] = useState<any>([]);
  const [savedPaytmConfig, setSavedPaytmConfig] = useState<any>([]);
  const [showPollingScreen, setShowPollingScreen] = useState(false);
  const query = new URLSearchParams(history.location.search);
  const orderId = query.get("orderId");
  const contentRefs = useRef([] as {[key: number]: HTMLElement | null});
  // used to fire tracking only once
  const trackRef = useRef(true);

   // used for hiding circular loader in paymentFailureFlow
   const failureFlowEnabled = NewPaymentFailure?.switchEnabled && NewPaymentFailure?.experimentEnabled;
   const isFailureUrl = failureFlowEnabled && window?.location?.href?.includes("paymentFailureOrderId");

  const visibleOfferBottomSheet = paymentContext?.visibleOfferBottomSheet;
  const setVisibleOfferBottomSheet = paymentContext?.setVisibleOfferBottomSheet;
  const cashFreePaymentGateway = cartInfo?.paymentGateway;

  const isAllUpiIntentAvailableOnWeb = checkAllUpiIntentVisibilityOnWeb({
    availablePaymentMethods,
    isExperimentEnable: UpiIntentMweb.experimentEnabled && UpiIntentMweb.switchEnabled,
    cashFreePaymentGateway,
  });

  // passing extra parameters from context to doPaymentFactory
  const handleDoPaymentFactory = (method: string, params: any) => {
    let finalMethod = method;
    if (method === PAYMENT_METHODS.CREDIT_CARD) {
      finalMethod = PAYMENT_MODES.SAVED_CARD;
    }
    const requestParams: any = {
      cartInfo,
      paymentInfo,
      isGuest,
      history,
      flow,
      deviceType,
      isOtpVerificationRequired: isOtpVerificationRequired && flow !== PAYMENT_FLOWS.WALLET, // on wallet screen otpVerification is not needed
      isApp,
      pciEnabled: PciExperiment.experimentEnabled,
      offerInfo,
      metaDataTags: [],
      applyCartCharges: !!ConvenienceCharges?.experimentEnabled,
    };

    if (flow === PAYMENT_FLOWS.COD_TO_PREPAID) {
      requestParams.orderId = orderId;
    }

    if (finalMethod === PAYMENT_MODES.SAVED_CARD) {
      requestParams.sdkTypeIframeId = PCI_IFRAME_IDS.SC;
    }

    const factoryCallbacks = {
      setLoading,
      setIsAutoCreateOrderLoading,
      openErrorModal,
      trackPayNowClick: trackPayNowClick,
      setIsVerifyOtpVisible,
      handleCallBackAfterVerification,
      doPaymentApi,
      setCartInfo,
      setIsPaymentProcessing,
      history,
    };
    // passing orderAmount for wallet flow
    if (flow == PAYMENT_FLOWS.WALLET && method == PAYMENT_MODES.GOOGLE_PAY) {
      params.values = {
        ...params.values,
        grandTotal: orderAmount,
        isSaved: true,
      };
    }

    const configParams = {
      walletConfig,
      giftCardConfig,
      values: params,
    };
    doPaymentHandler(finalMethod, configParams, requestParams, factoryCallbacks);
  };

  /**
   * This is to manage toggle state of saved method
   */
  const toggleSavedPaymentMethod = (index: number, isDisabled: boolean, method: string) => {
    setActiveMethodForSavedPayments(PAYMENT_TYPE.NON_PCI);
    /**
     * this state is for switching between saved and new payment methods.
    */
    setPaymentOption(PAYMENT_OPTION.SAVED);

    if (!isDisabled) {
      if (isWalletAccordianOpen) {
        setIsWalletAccordianOpen(false);
      }

      if (accordian === index) {
        setAccordian(-1);
      } else {
        /**
         * this is to track saved method click
         */
        trackPaymentMethodClick({ paymentMethod: method, isSaved: true, deviceType, isLoggedIn: !isGuest });
        // apps tracking in saved payment method change
        allTrackingHandlerForApps({ event: TRACKING_EVENTS.PAYMENT_METHOD_CLICK, paymentMethod:method, cartInfo, paymentInfo, isSavedPaymentMethod : true, isApp });

        /**
         * To maintain the view of accordian
        */
        setTimeout(() => {
          contentRefs?.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 400);

        setAccordian(index);
      }
    }
  };

  /**
   * This to manage offersBottom sheet
   * this method will be passed as callback
   */

  const [offersData, setOffersData] = useState<any>({});
  const [offerVisible, setOfferVisible] = useState(false);

  const toggleOfferBottomSheet = (offerData: any) => {
    if (Object.keys(offerData).length) {
      setOfferVisible(true);
      if (setVisibleOfferBottomSheet) {
        setVisibleOfferBottomSheet(true);
      }
    }
    setOffersData(offerData);
  };

    /**
     * function for opening and closing upi intent polling screen on mweb.
    */
    const handleMwebIntentPollingScreen = (value: boolean) => {
      setShowPollingScreen(value);
    };

  useEffect(() => {
    if (!visibleOfferBottomSheet && offerVisible) {
      setOfferVisible(false);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [visibleOfferBottomSheet]);

  useEffect( () => {
    /* eslint-disable no-shadow */
    const offerInfo = getPaymentOfferInfoConfig({
      offerData: offersData,
      theme,
      action: () => {
        if (offerVisible) {
          toggleOfferBottomSheet({});
          if (setVisibleOfferBottomSheet) {
            setVisibleOfferBottomSheet(false);
          }
          setOfferVisible(false);
        }
      },
      deviceType,
      isVisible: offerVisible,
    });
    setOfferInfoConfig(offerInfo);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [offerVisible]);


  /**
   * need to improve
   * when wallet is open then close all other saved method &
   * When saved card is then also close all other saved payment option
   * as saved card is managed in PCI repo
   */
  useMemo(() => {
    if (
      isWalletAccordianOpen ||
      activeMethodForSavedPayments === PAYMENT_TYPE.PCI ||
      paymentOption === PAYMENT_OPTION.NEW
    ) {
      setAccordian(-1);
    }

    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isWalletAccordianOpen, activeMethodForSavedPayments, paymentOption]);

  useMemo(() => {
    if (!isPaymentInfoLoading) {
      const intentAvailableOnWeb = isAllUpiIntentAvailableOnWeb || isGPayIntentAvailable;
      const activeSavedMethod = getValidSavedMethod({
        paymentContext,
        isGPayIntentAvailable: intentAvailableOnWeb,
        isApp,
      });
      const lastPaymentMode = toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode);

      /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
      let allConfigs = [] as (ISavedUpiIntent| ISavedPaytmConfigs| ISavedsnplConfig| ISavedUpiConfigs| ISavedNetBanking | IsavedCardConfig)[];
      let lastPaymentConfig = {} as (ISavedUpiConfigs | ISavedsnplConfig | ISavedNetBanking);
      let upiConfigs = [] as ISavedUpiConfigs[];
      let paytmConfig = {} as ISavedPaytmConfigs;
      let shopNowPayLaterConfig = {} as ISavedsnplConfig;
      let upiIntent = {} as ISavedUpiIntent;
      let cardConfig = {} as IsavedCardConfig;
      let savedPayTmConfig = [] as (ISavedPaytmConfigs)[];

      /**
       * This config is common to all method
       */
      const commonConfig = {
        paymentContext,
        applicationData,
        orderAmount,
        doPayment: handleDoPaymentFactory,
        toggleOfferBottomSheet,
        strikedPaymentText: showStrikedAmount ? getStringFromId(
          VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
          `Pay ₹${formatNumber(orderAmount)} &nbsp; <del> ₹${formatNumber(initialOrderAmount)} </del>`,
          {
            oldAmount: initialOrderAmount,
            newAmount: orderAmount,
          }
        ) : "",
        isApp,
        theme,
        setUpiDetails,
        isAllUpiIntentAvailableOnWeb,
        handleMwebIntentPollingScreen,
      };
      /**
       * this block get the lastPaymentInfo config
       * and push to array
       */
      if (paymentInfo?.lastPaymentInfo && activeSavedMethod.includes("last")) {
        if (lastPaymentMode === PAYMENT_MODES.NET_BANKING) {
          lastPaymentConfig = getSavedNbContextData(commonConfig);
        } else if (lastPaymentMode === PAYMENT_MODES.UPI) {
          const lastPaymentUpiConfig = getSavedUpiMethodContextData({ ...commonConfig, timerCallback, setUpiDetails, isLastPayment: true }) || [];

          if (Array.isArray(lastPaymentUpiConfig) && lastPaymentUpiConfig.length !== 0) {
            lastPaymentConfig = lastPaymentUpiConfig[0];
          }
        } else if (lastPaymentMode === PAYMENT_MODES.SIMPL) {
          lastPaymentConfig = savedSimpl(commonConfig);
        }

        if (Object.keys(lastPaymentConfig || {}).length !== 0) {
          allConfigs.push(lastPaymentConfig);
        }
      }

      /**
       * this block get the upi_intent config
       * and push to array
       */
      if (activeSavedMethod.includes(toLowerCase(PAYMENT_MODES.UPI_INTENT))) {
        upiIntent = getUpiIntentContextData({ ...commonConfig, timerCallback, setUpiDetails }) || {};
        if (Object.keys(upiIntent || {}).length !== 0) {
          allConfigs.push(upiIntent);
        }
      }

      /**
       * this block get the UPI config
       * and push to array
       */
      if (activeSavedMethod.includes(PAYMENT_MODES.UPI)) {
        upiConfigs = getSavedUpiMethodContextData({ ...commonConfig, timerCallback, setUpiDetails });
        if (Array.isArray(upiConfigs) && upiConfigs.length !== 0) {
          allConfigs.push(...upiConfigs);
        }
      }

      /**
       * this block get the paytm config
       * and push to array
       */
      if (activeSavedMethod.includes(PAYMENT_MODES.PAYTM)) {
        paytmConfig = getSavedPaytmContextData(commonConfig);
        if (Object.keys(paytmConfig || {}).length !== 0) {
          allConfigs.push(paytmConfig);
          savedPayTmConfig.push(paytmConfig);
          setSavedPaytmConfig(savedPayTmConfig);
        }
      }
      /**
       * this block get the SIMPL config if lastPaymentMode is not simpl
       * and push to array
       */
      if (activeSavedMethod.includes(PAYMENT_MODES.SIMPL) && (lastPaymentMode !== ACCORDIAN.SIMPL)) {
        shopNowPayLaterConfig = savedSimpl(commonConfig);
        if (Object.keys(shopNowPayLaterConfig || {}).length !== 0) {
          allConfigs.push(shopNowPayLaterConfig);
        }
      }

      /**
       * this block get the savedcard config
       * all the config is manage in PCI repo this config
       * is to make thing similar to others
       * and push to array
       */
      if (paymentInfo?.savedCardDTOList?.length) {
        cardConfig = {
          pymentMethod: PAYMENT_MODES.CREDIT_CARD,
          priority: 0,
        };
        allConfigs.push(cardConfig);
      }

      allConfigs.sort((a, b) => a?.priority - b?.priority);
      setAllSavvedPaymentConfig(allConfigs);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [paymentContext, orderAmount, isPaymentInfoLoading, isOtpVerificationRequired, isGPayIntentAvailable]);

  /**
   * tracking for all rendered saved payment methods
   */
  useEffect(() => {
    if (allSavedPaymentConfig?.length > 0 && !loading && trackRef.current) {
      trackRef.current = false;
      const allSavedPaymentMethods = allSavedPaymentConfig.map((paymentConfig: any) => paymentConfig.pymentMethod);
      trackRenderedSavedMethods({ allSavedPaymentMethods });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [allSavedPaymentConfig]);

  useMemo(() => {
    if (autoPayTmCreateOrder && savedPaytmConfig?.length) {
      /** Sending an automatic payment call when user have sufficient balance in paytm to create order,
       * Sent when autoPayTmCreateOrder is true
      */

      /**
       * This config is common to all method
      */
      const commonConfig = {
        paymentContext,
        applicationData,
        orderAmount,
        doPayment: handleDoPaymentFactory,
        toggleOfferBottomSheet,
        theme,
      };
      let paytmConfig = getSavedPaytmContextData(commonConfig);
      const walletBalance = commonConfig?.paymentContext?.walletInfo?.balance;
      // preventing auto create order when user have some wallet balance
      if (!paytmConfig?.amountToAdd && !walletBalance) {
        paytmConfig.doPayment();
      } else {
        setIsAutoCreateOrderLoading(false);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [savedPaytmConfig?.length]);

  /**
   * By default show the first available payment option from the list of saved options.
   */
  useEffect(() => {
    if (
      allSavedPaymentConfig.length &&
      paymentScreen === PAYMENT_SCREENS.SAVED &&
      !isWalletAccordianOpen
    ) {
      setPaymentOption(PAYMENT_OPTION.SAVED);
      setAccordian(0);
    }
    if (allSavedPaymentConfig.length === 0) {
      setPaymentOption(PAYMENT_OPTION.NEW);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [allSavedPaymentConfig.length, paymentScreen]);

  return (
    <>
      {loading && !isFailureUrl && <OverlayLoader isActive={loading} zIndex={2} loadingParams = {loadingParams}/>}
      <SavedPaymentWrapper
        className={`layout vertical payment-view visible-layer ${isFullPaymentByGiftCard && "disabled-layer"}`}
        data-testid="lb_paymentMethods"
      >
        {(allSavedPaymentConfig.length !== 0 || paymentInfo?.savedCardDTOList?.length !== 0) &&
          <SectionTitleWrapper>
            <Text
              text={SavedPaymentOption}
              font={theme.typography.sectionTitle}
              color={theme.primaryText}
              theme={theme}
              data-testid="txt_saved_payment_option"
            />
          </SectionTitleWrapper>
        }

        {allSavedPaymentConfig?.map((paymentConfig: any, index: number) => {
          const isAccordianOpened = accordian === index && !paymentConfig?.isDisabled;

          const finalConfig = {
            key: index,
            ...paymentConfig,
            isAccordianOpened,
            toggleAccordian: () => toggleSavedPaymentMethod(index, paymentConfig?.isDisabled, paymentConfig?.pymentMethod),
            endIcon: getEndIconforPaymentMethod(deviceType, isAccordianOpened),
          };

          {isAccordianOpened &&
            setTimeout(() => {
              contentRefs.current[index]?.getElementsByClassName("input-element")[0]?.focus({ preventScroll: true });
            }, 80);
          }
          switch (paymentConfig?.pymentMethod) {
            case ACCORDIAN.PAYTM:
              return <div key={`savedPayment-${index}`} ref = {el => contentRefs.current[index] = el}>
                <SavedPaytmWallet {...finalConfig} />
              </div>;
            case ACCORDIAN.UPI:
              return <div key={`savedPayment-${index}`} ref={el => contentRefs.current[index] = el}>
                <SavedUpi {...finalConfig} />
              </div>;
            case ACCORDIAN.NETBANKING:
              return <div key={`savedPayment-${index}`} ref={el => contentRefs.current[index] = el}>
                <SavedNB {...finalConfig} />
              </div>;
            case ACCORDIAN.GPAY_INTENT:
              return (
                <div key={`savedPayment-${index}`} ref={el => (contentRefs.current[index] = el)}>
                  <GooglePay {...finalConfig} />
                  {UpiIntentMwebPollingScreen.experimentEnabled && (
                    <UpiIntentPollingScreen
                      theme={theme}
                      showPollingScreen={showPollingScreen}
                      handleMwebIntentPollingScreen={handleMwebIntentPollingScreen}
                      history={history}
                    />
                  )}
                </div>
              );
            case ACCORDIAN.SIMPL:
              return <div key={`savedPayment-${index}`} ref={el => contentRefs.current[index] = el}>
                <SavedSimpl {...finalConfig} />
                <RelinkSimplMobile
                  isBottomSheetVisible={paymentConfig?.relinkBottomSheetConfig?.isVisible}
                  text={paymentConfig?.relinkBottomSheetConfig?.subTitle}
                  successButtonText={paymentConfig?.relinkBottomSheetConfig?.successButtonText}
                  dismissButtonText={paymentConfig?.relinkBottomSheetConfig?.dismissButtontext}
                  onSuccess={paymentConfig?.relinkBottomSheetConfig?.onSuccess}
                  onDismiss={paymentConfig?.relinkBottomSheetConfig?.onDismiss}
                  relinkTitle={paymentConfig?.relinkBottomSheetConfig?.title}
                  theme={paymentConfig?.theme}
                />
              </div>;
            case ACCORDIAN.CREDIT_CARD:
                return <PCI
                  paymentContext={paymentContext}
                  sdkType={PciSdkTypes.SAVED}
                  doPayment={handleDoPaymentFactory}
                  deviceType={deviceType}
                  setLoading={setLoading}
                  /**
                   * allSavedPaymentConfig contains config which will be shown on saved payment screen
                   * by default 0 index element will be open but for cards, handling is done in PCI repo,
                   * so if cc is present on 0th element, we will show it open by default.
                   */
                  lastInfoAvailable={!(allSavedPaymentConfig.length === 1 && allSavedPaymentConfig[0]?.pymentMethod == "cc")}
                />;
            default:
              return <></>;
          }
        })}
      </SavedPaymentWrapper>
      {Boolean(Object.keys(offerInfoConfig)?.length) && <PaymentOfferInfo {...offerInfoConfig} history={history}/>}
    </>
  );
};
